export const EXPANDING_DURATION_MS = 300;
export const EXPANDING_EASING = 'ease-in-out';
export const BORDER_RADIUS = 8;
